import {
  Button,
  Col,
  Modal,
  Row,
  Spin,
  Table,
  Tooltip,
  Form,
  Input,
  Select,
  Switch,
  Icon,
  DatePicker,
} from "antd";
import React, { Component } from "react";
import MyModal from "../../Modal";
import DropdownCountry from "../../SearchForm/dropdown-country";
import offerService from "../../OfferManagement/service";
import adminService from "../../GatewayCountryLogs/services";
import { debounce } from "lodash";
import moment from "moment";

const ButtonGroup = Button.Group;

class UserSellPriceModal extends Component {
  state = {
    loading: false,
    currentPage: 1,
    currentSearch: "",
    dataSource: [],
    totalRows: 0,
    current_data: {
      rates: "",
      region_code: "",
      expired: null,
      member_id: 0,
      offer_id: 0,
    },
    countryList: [],
    allowCountries: [],
    flagCreateOrUpdateForm: true, // true: created, false: updated
    visibleFormModal: false,
    adminList: [],
  };
  memberID = this.props.data.memberId;

  async componentDidMount() {
    this.setState({
      loading: true,
    });
    const defaultSearch = JSON.stringify({ member_id: this.memberID });
    const adminList = await adminService.getAdminLists();
    const { data, total_rows } = await offerService.getOfferList(
      1,
      10,
      defaultSearch
    );
    const propsCountryList = JSON.parse(
      JSON.stringify(this.props.countryList || [])
    );
    propsCountryList.shift();

    this.setState({ adminList: adminList.list });

    //filter country that allow user to add / update
    const allowCountries = [];
    for (const offer of data || []) {
      const country = offer.country_abbr;
      if (!allowCountries.find((c) => c === country)) {
        allowCountries.push(country);
      }
    }

    const filteringCountries = propsCountryList.filter(
      (c) => !allowCountries.includes(c.region_code)
    );

    this.setState({
      countryList: propsCountryList,
      currentSearch: defaultSearch,
      dataSource: data,
      totalRows: total_rows,
      loading: false,
      allowCountries: filteringCountries,
    });
  }

  columns = [
    {
      title: "Create By",
      dataIndex: "created_by",
      render: (created_by) => {
        return this.findCreatByName(created_by);
      },
      align: "center",
    },
    {
      title: "Create Time",
      dataIndex: "created",
      render: (created) => {
        if (!created.Valid) return "-";
        return moment(created.Time).format("MMM DD YYYY HH:mm");
      },
      align: "center",
    },
    {
      title: "Offer Rates",
      dataIndex: "price",
      align: "center",
    },
    {
      title: "Country",
      dataIndex: "country_abbr",
      render: (text) => {
        const findCountry = this.state.countryList.find(
          (c) => c.region_code === text
        );
        if (!findCountry) {
          return "-";
        }
        return findCountry.name;
      },
      align: "center",
    },
    {
      title: "Expire Date",
      dataIndex: "expired",
      align: "center",
      render: (expired) => {
        if (!expired.Valid) {
          return "-";
        }
        const datetime = new Date(expired.Time);
        return moment(datetime).format("MMM DD YYYY");
      },
    },
    {
      title: "Last Update",
      dataIndex: "updated",
      render: (updated) => {
        if (!updated.Valid) return "-";
        const datetime = new Date(updated.Time);
        return moment(datetime).format("MMM DD YYYY HH:mm");
      },
      align: "center",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (v, record) => {
        return (
          <Switch
            checkedChildren={<Icon type="check" />}
            unCheckedChildren={<Icon type="close" />}
            checked={v === "enabled"}
            onChange={(e) => this.toggleStatus(e, record.id)}
          />
        );
      },
      align: "center",
    },
    {
      title: "Action",
      dataIndex: "id",
      render: (id, record) => {
        return (
          <div>
            <ButtonGroup>
              <Tooltip placement="top" title="แก้ไข">
                <Button icon="edit" onClick={() => this.edit(record)} />
              </Tooltip>
              <Tooltip placement="top" title="ลบ">
                <Button
                  type="danger"
                  icon="delete"
                  onClick={() => this.delete(record)}
                />
              </Tooltip>
            </ButtonGroup>
          </div>
        );
      },
      align: "center",
    },
  ];
  limit = 10;

  toggleStatus = (status, id = 0) => {
    if (!id) return;

    let textConfirm = "ปิดการใช้งาน";
    if (status) {
      textConfirm = "เปิดการใช้งาน";
    }

    status = !status === true ? "enabled" : "disabled";

    MyModal.confirm(
      `ยืนยัน ${textConfirm} ใช่หรือไม่ ?`,
      "",
      async (isConfirm) => {
        if (!isConfirm) {
          return;
        }

        let res;
        this.setState({ loading: true });

        try {
          res = await offerService.updateStatus(id, status);
          MyModal.success(`${textConfirm} สำเร็จ`);

          const { data, total_rows } = await offerService.getOfferList(
            this.state.currentPage,
            this.limit,
            this.state.currentSearch
          );
          this.setState({
            loading: false,
            dataSource: data,
            totalRows: total_rows,
          });
        } catch (e) {
          MyModal.error(
            "เกิดข้อผิดพลาด ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง",
            res.error.description
          );
          this.setState({ loading: false });
        }
      },
      "ยืนยัน",
      "ยกเลิก"
    );
  };

  changePage = async (page) => {
    this.setState({
      currentPage: page,
      loading: true,
    });

    const { data, total_rows } = await offerService.getOfferList(
      page,
      this.limit,
      this.state.currentSearch
    );
    this.setState({
      loading: false,
      dataSource: data,
      totalRows: total_rows,
    });
  };

  create = async () => {
    this.setState({
      current_data: {
        rates: "",
        region_code: "",
        expired: null,
        member_id: this.memberID,
        offer_id: 0,
      },
      flagCreateOrUpdateForm: true,
      visibleFormModal: true,
    });
  };

  delete = (value) => {
    if (!value.id) return;
    const findCountry = this.state.countryList.find(
      (c) => c.region_code === value.country_abbr
    );
    MyModal.confirm(
      "ต้องการลบรายการนี้ ใช่หรือไม่ ?",
      <span>
        Rates: {value.price}&nbsp;&nbsp;&nbsp;ประเทศ: {findCountry.name || "-"}
      </span>,
      async (isConfirm) => {
        if (!isConfirm) return;

        this.setState({ loading: true });

        try {
          await offerService.updateStatus(value.id, "delete");
          MyModal.success("ลบรายการสำเร็จ");
        } catch (e) {
          MyModal.error(
            "เกิดข้อผิดพลาด ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง"
          );
        }

        const { data, total_rows } = await offerService.getOfferList(
          1,
          this.limit,
          this.state.currentSearch
        );
        this.setState({
          loading: false,
          dataSource: data,
          totalRows: total_rows,
        });
      },
      "ยืนยัน",
      "ยกเลิก"
    );
  };

  edit = async (value) => {
    if (!value.id) return;
    this.setState({
      current_data: {
        rates: value.price,
        region_code: value.country_abbr,
        expired: value.expired,
        offer_id: value.id,
      },
      flagCreateOrUpdateForm: false,
      loading: false,
      visibleFormModal: true,
    });
  };

  formHandleSubmit = () => {
    const { form } = this.formRef.props;
    if (!this.memberID) return;

    form.validateFields(async (err, values) => {
      if (err) return;

      MyModal.confirm(
        "ยืนยันบันทึกข้อมูล ใช่หรือไม่ ?",
        "",
        async (isConfirm) => {
          if (!isConfirm) return;

          this.setState({ loading: true });

          const modeText = this.state.flagCreateOrUpdateForm
            ? "เพิ่ม"
            : "แก้ไข";
          const errorMsg = `เกิดข้อผิดพลาด ไม่สามารถ${modeText}ข้อมูลได้ กรุณาลองใหม่อีกครั้ง`;
          const work = this.state.flagCreateOrUpdateForm
            ? offerService.addOffer
            : offerService.updateOffer;

          const payload = {
            member_id: this.memberID,
            price: parseFloat(values.rates),
            country_abbr: values.region_code,
            expired: values["expired"],
            id: this.state.current_data.offer_id,
          };

          const tmpDate = values["expired"]
            .endOf("day")
            .format("YYYY-MM-DD HH:mm:ss");
          payload["expired"] = tmpDate;

          //remove country if it wasn't provide
          if (!values["region_code"]) {
            payload.country_abbr = this.state.current_data.region_code;
          }

          try {
            await work(payload);
            MyModal.success(`${modeText}ข้อมูลสำเร็จ`, "", async () => {
              const { data, total_rows } = await offerService.getOfferList(
                1,
                this.limit,
                this.state.currentSearch
              );
              this.setState({
                totalRows: total_rows,
                dataSource: data,
              });
              this.resetState();
            });
          } catch (e) {
            let eMsgDetail = "";
            if (e.response && e.response.data && e.response.data.error) {
              const tmp = e.response.data.error;
              eMsgDetail = `[${tmp.code || ""}] ${tmp.name || ""}`;
            }
            MyModal.error(errorMsg, eMsgDetail, () => this.resetState());
          }
        },
        "ยืนยัน",
        "ยกเลิก"
      );
    });
  };

  findCreatByName = (adminId) => {
    if (adminId === 0) return "Admin System";
    const admin = this.state.adminList.find((admin) => admin.id === adminId);
    return admin ? admin.firstname + "" + admin.lastname : "-";
  };

  resetState = () => {
    this.setState({
      current_data: {
        rates: "",
        region_code: "",
        expired: null,
        offer_id: 0,
      },
      flagCreateOrUpdateForm: true,
      loading: false,
      visibleFormModal: false,
    });
  };

  formHandleCancel = () => {
    this.setState({
      visibleFormModal: false,
      current_data: {
        rates: "",
        region_code: "",
      },
    });
  };

  mySearch = (fd) => {
    fd.validateFields(async (err, values) => {
      if (err) return;

      const currentPage = 1;
      const tmpSearch = JSON.parse(this.state.currentSearch);
      const currentSearch = { ...tmpSearch, counties: `'${values.country}'` };
      const stringifySearch = JSON.stringify(currentSearch);

      const { data, total_rows } = await offerService.getOfferList(
        this.state.currentPage,
        this.limit,
        stringifySearch
      );

      this.setState({
        currentPage,
        currentSearch: stringifySearch,
        totalRows: total_rows,
        dataSource: data,
        loading: true,
      });

      this.setState({ loading: false });
    });
  };

  resetSearch = async () => {
    this.setState({ loading: true });
    const tmpSearch = JSON.parse(this.state.currentSearch);
    delete tmpSearch.counties;
    const stringifySearch = JSON.stringify(tmpSearch);

    const { data, total_rows } = await offerService.getOfferList(
      this.state.currentPage,
      this.limit,
      stringifySearch
    );
    this.setState({
      currentPage: 1,
      currentSearch: stringifySearch,
      loading: false,
      dataSource: data,
      totalRows: total_rows,
    });
  };

  saveFormRef = (formRef) => {
    this.formRef = formRef;
  };

  render() {
    const { data, onCancel, visible } = this.props;
    const memberName = data ? data.memberName || "-" : "-";
    const propsTable = {
      bordered: true,
      className: "my-table",
      columns: this.columns,
      dataSource: this.state.dataSource,
      rowKey: "id",
      pagination: {
        pageSize: this.limit,
        total: this.state.totalRows,
        current: this.state.currentPage,
        onChange: this.changePage,
        size: "small",
      },
      size: "small",
      scroll: {
        x: 800,
      },
    };

    const propsTableForMobile = Object.assign({}, propsTable);

    propsTableForMobile.className = "my-table-mobile";
    propsTableForMobile.columns = this.columns;

    let title = `Special Price ของ ${memberName}`;

    return (
      <Modal
        className="my-layout"
        footer={[
          <Button key="cancel" onClick={onCancel}>
            ปิด
          </Button>,
        ]}
        maskClosable={false}
        onCancel={onCancel}
        title={title}
        visible={visible}
        width={1200}
      >
        <Spin spinning={this.state.loading} tip="กำลังโหลดข้อมูล...">
          <Row className="utility-bar">
            <Col sm={24} md={6}>
              <Button
                icon="plus-circle"
                type="primary"
                onClick={() => this.create()}
              >
                Add Offer
              </Button>
            </Col>
            <Col sm={24} md={18}>
              <DropdownCountry fn={this.mySearch} fnReset={this.resetSearch} />
            </Col>
          </Row>
          <Table {...propsTable} />
          <Table {...propsTableForMobile} />
        </Spin>
        <UserSellPriceForm
          data={this.state.current_data}
          countryList={this.state.allowCountries}
          flagCreateOrUpdateForm={this.state.flagCreateOrUpdateForm}
          onCancel={this.formHandleCancel}
          onSubmit={this.formHandleSubmit}
          visible={this.state.visibleFormModal}
          wrappedComponentRef={this.saveFormRef}
          newLogic={true}
        />
      </Modal>
    );
  }
}

export const UserSellPriceForm = Form.create({ name: "user_sell_price_form" })(
  class extends Component {
    state = {
      searchLoading: false,
      memberList: [],
    };
    componentDidUpdate = async (prevProps, prevState) => {
      const { data: pd } = prevProps;
      const { data: d, form } = this.props;

      if (d && d.rates !== pd.rates) {
        if (d["expired"]) {
          //rename expired date
          d["expired"] = d["expired"]["Valid"]
            ? moment(d["expired"]["Time"])
            : null;
        }
        form.setFieldsValue(d);
      }
    };

    handleOnSearchMember = async (input) => {
      this.setState({
        searchLoading: true,
      });
      // ? check if input is null
      let res = [];
      if (input !== "") {
        res = await offerService.searchMemberList(input);
      }

      this.setState({
        searchLoading: false,
        memberList: res,
      });
    };

    render() {
      const {
        visible,
        onSubmit,
        onCancel,
        form,
        flagCreateOrUpdateForm,
        countryList,
        newLogic,
        data,
      } = this.props;
      const { getFieldDecorator } = form;

      let okText = flagCreateOrUpdateForm ? "เพิ่ม" : "แก้ไข";
      let title = `${okText} Rates`;

      return (
        <Modal
          visible={visible}
          title={title}
          okText={okText}
          cancelText="ยกเลิก"
          onCancel={onCancel}
          onOk={() => onSubmit(form)}
          maskClosable={false}
          style={{ top: 20 }}
        >
          <Form>
            {getFieldDecorator("id")(<Input type="hidden" />)}
            {newLogic && flagCreateOrUpdateForm && (
              <Form.Item label="ผู้ใช้งาน">
                {getFieldDecorator("member_id", {
                  rules: [
                    {
                      required: data.member_id ? false : true,
                      message: "กรุณาเลือกผู้ใช้งาน",
                    },
                  ],
                })(
                  <Select
                    allowClear
                    showSearch
                    placeholder="ผู้ใช้งาน"
                    optionFilterProp="children"
                    //? delay input by using debouce for 0.6 second
                    onSearch={debounce(this.handleOnSearchMember, 600)}
                    loading={this.state.searchLoading}
                    disabled={data.member_id}
                  >
                    {this.state.memberList.map((item, i) => (
                      <Select.Option key={i} value={item.id}>
                        {item.email}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            )}
            {newLogic && (
              <Form.Item label="วันหมดอายุ">
                {getFieldDecorator("expired", {
                  rules: [
                    { required: true, message: "กรุณาเลือกวันหมดอายุของราคา" },
                  ],
                })(
                  <DatePicker
                    style={{ width: "100%" }}
                    disabledDate={(c) => c && c.valueOf() < Date.now()}
                  />
                )}
              </Form.Item>
            )}
            <Form.Item label="Rates">
              {getFieldDecorator("rates", {
                rules: [
                  {
                    pattern: new RegExp("^[0-9]+([.][0-9]{1,4})?$"),
                    message:
                      "กรุณากรอกเป็นตัวเลขและเลขทศนิยมได้ไม่เกิน 4 ตัวเท่านั้น",
                  },
                  { required: true, message: "กรุณากรอก Rates" },
                ],
              })(<Input placeholder="Rates" />)}
            </Form.Item>
            {flagCreateOrUpdateForm ? (
              <Form.Item label="ประเทศ">
                {getFieldDecorator("region_code", {
                  rules: [{ required: true, message: "กรุณาเลือกประเทศ" }],
                })(
                  <Select
                    showSearch
                    placeholder="ประเทศ"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {(countryList || []).map((item, i) => (
                      <Select.Option key={i} value={item.region_code}>
                        {item.name}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            ) : null}
          </Form>
        </Modal>
      );
    }
  }
);

export default UserSellPriceModal;



// WEBPACK FOOTER //
// ./src/containers/User/UserManagement/UserSellPriceModal.js